/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'

import Menu from '../../../../components/CustomerClub/Menu'

import { useForm } from "react-hook-form"

import { post } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

export default function index() {
  document.title = 'مشتری'

  const navigate = useNavigate()

  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  const onSubmit = (data, e) => {
    e.preventDefault()
    post(`/api/admin/ccusers?token=${token}`, {
      name: data.name,
      phoneNumber: data.phoneNumber,
      email: data.email
    }).then(response => {
      console.log(response)
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/cc/users')
      }, 2000)
    }).catch(error => {
      if (error.response.data.messageFa === "کاربری با این مشخصات یافت شد") {
        return notify('error', 'کاریری با این مشخصات موجود می باشد')
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }
  
  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'user'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
              </div>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * اطلاعات کاربر فقط جهت نمایش است. برای غیرفعال کردن کاربر جهت عدم دسترسی به اپلیکیشن از سوییچ بالا استفاده کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات کاربر
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام و نام خانوادگی :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا علی' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>شماره موبایل :</label>
                <input id='foodPrice' {...register("phoneNumber", { required: true, minLength: 11 })} className='ltrdirection' type='text' placeholder='09...' />
                <small id='foodPriceAlert'>شماره موبایل باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>آدرس ایمیل :</label>
                <input id='foodLeveleDetails' className='ltrdirection' {...register("email", { })} type='text' />
                <small id='foodLeveleDetailsAlert'>آدرس ایمیل باید وارد شود</small>
              </div>
            </div>

            <button className='createButton'>ایجاد مشتری</button>
          </form>

          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
